import React from 'react';

export default function AthPatrika({ onBackClick }) {
  const handleBack = () => {
    if (onBackClick) {
      onBackClick('agripaper');
    }
  };

  const [selectedPdf, setSelectedPdf] = React.useState(null);
  const pdfViewerRef = React.useRef(null);

  React.useEffect(() => {
    if (selectedPdf !== null && pdfViewerRef.current) {
      setTimeout(() => {
        pdfViewerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  }, [selectedPdf]);

  const pdfList = [
    { name: 'ඕකිඩ් වගාව', file: '/pdf/ඕකිඩ් වගාව.pdf' },
    { name: 'කාබනික දියර පොහොර නිෂ්පාදනය', file: '/pdf/කාබනික දියර පොහොර නිෂ්පාදනය.pdf' },
    { name: 'කොම්පෝස්ට් පොහොර නිෂ්පාදනය', file: '/pdf/කොම්පෝස්ට් පොහොර නිෂ්පාදනය.pdf' },
    { name: 'ගුනාත්මක බිජ වී භාවිතය', file: '/pdf/ගුනාත්මක බිජ වී භාවිතය.pdf' },
    { name: 'පරිසර හිතකාමී පලිබෝධ නාශක භාවිතය', file: '/pdf/පරිසර හිතකාමී පලිබෝධ නාශක භාවිතය.pdf' },
    { name: 'පලතුරු වගාව - 01', file: '/pdf/පලතුරු වගාව - 01.pdf' },
    { name: 'පස් සංරක්ෂණය - 01', file: '/pdf/පස් සංරක්ෂණය - 01.pdf' },
    { name: 'බොන්සායි කලාව - 01', file: '/pdf/බොන්සායි කලාව - 01.pdf' },
    { name: 'බොන්සායි කලාව - 02', file: '/pdf/බොන්සායි කලාව - 02.pdf' },
    { name: 'බොන්සායි කලාව - 03', file: '/pdf/බොන්සායි කලාව - 03.pdf' },
    { name: 'බොන්සායි කලාව - 04', file: '/pdf/බොන්සායි කලාව - 04.pdf' },
    { name: 'බොන්සායි කලාව - 05', file: '/pdf/බොන්සායි කලාව - 05.pdf' },
    { name: 'බොන්සායි කලාව -06', file: '/pdf/බොන්සායි කලාව -06.pdf' },
    { name: 'වී වගාව සදහා යන්ත්‍ර භාවිතය', file: '/pdf/වී වගාව සදහා යන්ත්‍ර භාවිතය.pdf' },
    { name: 'වී වගාවෙන් සරු අස්වැන්නක් - 01', file: '/pdf/වී වගාවෙන් සරු අස්වැන්නක් - 01.pdf' },
    { name: 'වී වගාවෙන් සරු අස්වැන්නක් - 03', file: '/pdf/වී වගාවෙන් සරු අස්වැන්නක් - 03.pdf' },
    { name: 'වී වගාවෙන් සරු අස්වැන්නක් - 06', file: '/pdf/වී වගාවෙන් සරු අස්වැන්නක් - 06.pdf' },
    { name: 'වී වගාවේ දළඹු හානිය පාලනය', file: '/pdf/වී වගාවේ දළඹු හානිය පාලනය.pdf' },
  ];

  return (
    <section className="agripaper-section" aria-label="Ath Patrika">
      <div className="agripaper-header">
        <button
          className="back-button"
          onClick={handleBack}
          style={{
            backgroundColor: '#0b6b2f',
            color: 'white',
            border: 'none',
            padding: '8px 16px',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px',
            marginBottom: '12px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}
          aria-label="Back to Agriculture Publications"
        >
          ← ආපසු
        </button>
        <h1 style={{ color: '#0b6b2f', fontSize: 28, marginBottom: 12, textAlign: 'justify' }}>අත් පත්‍රිකා</h1>
        <hr className="footer-sep" />
      </div>

      <div style={{ padding: '20px', maxWidth: '1000px', margin: '0 auto' }}>

        {/* PDF List */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '10px',
          marginBottom: '30px'
        }}>
          {pdfList.map((pdf, index) => (
            <div
              key={index}
              style={{
                border: '1px solid #ddd',
                borderRadius: '8px',
                padding: '20px',
                backgroundColor: '#f9f9f9',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
              }}
            >
              <h3 style={{ color: '#0b6b2f', marginBottom: '12px', fontSize: '17px' }}>{pdf.name}</h3>

              <div style={{
                display: 'flex',
                gap: '10px',
                flexWrap: 'wrap'
              }}>
                <a
                  href={pdf.file}
                  download
                  style={{
                    display: 'inline-block',
                    backgroundColor: '#0b6b2f',
                    color: 'white',
                    padding: '8px 16px',
                    borderRadius: '4px',
                    textDecoration: 'none',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    fontSize: '14px',
                    transition: 'background-color 0.3s ease'
                  }}
                  onMouseOver={(e) => e.target.style.backgroundColor = '#094c23'}
                  onMouseOut={(e) => e.target.style.backgroundColor = '#0b6b2f'}
                  aria-label={`Download ${pdf.name} PDF`}
                >
                  📥 Download
                </a>

                <button
                  onClick={() => setSelectedPdf(selectedPdf === index ? null : index)}
                  style={{
                    display: 'inline-block',
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    padding: '8px 16px',
                    borderRadius: '4px',
                    border: 'none',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    fontSize: '14px',
                    transition: 'background-color 0.3s ease'
                  }}
                  onMouseOver={(e) => e.target.style.backgroundColor = '#45a049'}
                  onMouseOut={(e) => e.target.style.backgroundColor = '#4CAF50'}
                  aria-label={`View ${pdf.name} PDF`}
                >
                  👁️ View
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* PDF Viewer */}
        {selectedPdf !== null && (
          <div 
            ref={pdfViewerRef}
            style={{
            border: '1px solid #ddd',
            borderRadius: '8px',
            padding: '20px',
            marginBottom: '20px',
            backgroundColor: '#f9f9f9'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '16px'
            }}>
              <h2 style={{ color: '#0b6b2f', margin: 0 }}>{pdfList[selectedPdf].name}</h2>
              <button
                onClick={() => setSelectedPdf(null)}
                style={{
                  backgroundColor: '#f44336',
                  color: 'white',
                  border: 'none',
                  padding: '8px 16px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  fontSize: '14px',
                  transition: 'background-color 0.3s ease'
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#da190b'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#f44336'}
                aria-label="Close PDF viewer"
              >
                ✕ Close
              </button>
            </div>

            <div style={{
              width: '100%',
              height: '700px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              overflow: 'auto',
              backgroundColor: '#fff'
            }}>
              <iframe
                src={pdfList[selectedPdf].file}
                style={{
                  width: '100%',
                  height: '100%',
                  border: 'none'
                }}
                title={`${pdfList[selectedPdf].name} PDF`}
                aria-label="PDF viewer"
              />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
